import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './fonts/proximaNova/ProximaNova-Regular.ttf';
import './fonts/proximaNova/ProximaNova-Semibold.ttf';
import './fonts/proximaNova/ProximaNova-Bold.ttf';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
